/* Page — Phase B1 layout primitive.
 *
 * The content-area outer wrapper used by every route. Replaces the
 * inline `<div style={{ padding: var(--page-gutter), maxWidth: ..., margin: "0 auto" }}>`
 * pattern that lived at the top of every non-forecast view.
 *
 * Width tokens (one knob — no ad-hoc px values):
 *   - compact (640px) — small focused pages (404, market-not-supported)
 *   - narrow  (720px) — single-column forms (UserProfile)
 *   - default (960px) — standard admin layouts (AdminUsers, PlatformMap)
 *   - wide   (1100px) — data-heavy views (AdminAudit)
 *   - display (1200px) — full-bleed lab / showcase
 *
 * Phase B4 will add an optional `header` slot that renders a PageHeader
 * above the content; for now the primitive is intentionally minimal so
 * existing inline h1s can move into place without coordinating.
 */
import React from "react";

export type PageWidth = "compact" | "narrow" | "default" | "wide" | "display";

interface PageProps {
  width?: PageWidth;
  children: React.ReactNode;
  className?: string;
}

export default function Page({ width = "default", children, className = "" }: PageProps) {
  return (
    <div className={`v2-page v2-page--${width} ${className}`.trim()}>
      {children}
    </div>
  );
}
